// extracted by mini-css-extract-plugin
export default {"multipleSelect":"styles_multipleSelect__yJjvC"};